<template>
  <div class>
    <div class="right_content">
      <div class="change_inform">
        <div class="title">订单查询</div>
      </div>
      <div class="right_out">
        <div style="padding: 5px; margin: 10px">
          <span>订单编号</span>
          <el-input type="text" class="searchinput" v-model="Query.orderNumber" size="mini"></el-input>
          <span>收款条目</span>
          <el-input type="text" class="searchinput" v-model="Query.paymentType" size="mini"></el-input>
          <el-button id="search" @click="fnGetData">搜索</el-button>
        </div>
        <el-table class="table_wrap1" :data="tableData" style="width: 100%">
          <el-table-column prop="OrderNumber" label="订单编号"></el-table-column>
          <el-table-column prop="PaymentType" label="收款条目"></el-table-column>
          <el-table-column prop="PayAmount" label="支付金额(元)"></el-table-column>
          <el-table-column prop="PayTime" label="支付完成时间"></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <div class="btn_wrap">
                <el-button class="btn" @click="fnInvoiceData(scope.row.EnOrderNumber)" type="text" size="small">查看开票信息</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog title="开票信息" width="1000px" class="dialog-wrap form-module" :visible.sync="showDialog" :close-on-click-modal="false">
      <div class="change_inform">
        <el-table class="table_wrap1" :data="invoiceList" style="width: 100%" empty-text="该暂未完成开票，暂无开票信息!">
          <el-table-column prop="InvoiceTitle" label="发票抬头"></el-table-column>
          <el-table-column prop="InvoiceAmount" label="发票金额"></el-table-column>
          <el-table-column prop="BillType" label="发票类型"></el-table-column>
          <el-table-column prop="BillDate" label="开票日期"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-link :href="scope.row.BillFile" target="_blank">下载发票</el-link>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'aboutUs',
  components: {},

  data() {
    return {
      ClarifyStatus: [],
      Query: {},
      tableData: [],
      invoiceList: [],
      showDialog: false
    }
  },
  created() {},
  computed: {},
  mounted() {
    this.fnGetData()
  },
  methods: {
    fnGetData() {
      //加载列表信息
      let config = {
        params: {
          Query: JSON.stringify(this.Query)
        }
      }

      this.getRequest('SupplierLogin/GetSupplierOrderList', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.tableData = res.data.orderList
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    fnInvoiceData(EnOrderNumber) {
      this.invoiceList = []
      let config = {
        params: {
          EnOrderNumber: EnOrderNumber
        }
      }

      this.getRequest('SupplierLogin/GetInvoiceData', config)
        .then((res) => {
          if (res.data.errcode == 0) {
            this.invoiceList = res.data.invoiceList
            this.showDialog = true
          } else {
            this.$message.error(res.data.errmsg)
          }
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    handleClose() {
      this.showDialog = false
    }
  }
}
</script>
<style scoped lang="scss">
#search {
  width: 120px;
}

.searchinput {
  width: 180px;
  margin: 0 60px 0 10px;
}

.right_content {
  margin: 0 10px;
  height: 93%;
  background: #f7f7f7;
}

.right_out {
  width: 98%;
  margin: 0 auto;
}

.welcome {
  height: 40px;
  line-height: 40px;
}

.currentMenu {
  margin: 16px 5px;
}

.btn_wrap {
  .btn {
    color: #6a96bc;
    border: 1px solid #6a96bc;
    border-radius: 5px;
    padding: 2px 18px;
    margin: auto;
  }
}

.link {
  color: #0361b1;
  padding-right: 10px;
}
</style>